import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { LoggerService } from '../../../shared/services/logger/logger.service';
import { I2gNgTrackingActionBuilder } from 'i2g-ng-tracking';
import {
  ITrackingAction,
  ITrackingObject,
  TrackingScreenNamesEnum,
} from '../../../tracking/tracking.data';
import { AddPaymentDetailsBuilder } from './add-payment-details.builder';

@Component({
  selector: 'app-add-payment-details',
  templateUrl: './add-payment-details.component.html',
  styleUrls: ['./add-payment-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [AddPaymentDetailsBuilder],
})
export class AddPaymentDetailsComponent implements OnInit, OnDestroy {
  @Input() paymentDetails: string;
  @Input() trackingObject: ITrackingObject;
  @Input() trackingScreenName: TrackingScreenNamesEnum;

  @Output()
  onPaymentDetailsChange: EventEmitter<string> = new EventEmitter<string>();

  formControl: FormControl;
  triggerTrackingAction: ITrackingAction;

  constructor(
    private _loggerService: LoggerService,
    private _addPaymentDetailsBuilder: AddPaymentDetailsBuilder,
    private _trackingActionBuilder: I2gNgTrackingActionBuilder
  ) {}

  ngOnInit() {
    this.formControl = this._addPaymentDetailsBuilder.buildFormControl(
      this.paymentDetails
    );
    this.triggerTrackingAction = this._trackingActionBuilder.buildButtonTapped(
      'payment_details',
      this.trackingScreenName
    );
  }

  updatePaymentDetails() {
    this._loggerService.log('saving payment details');

    this.onPaymentDetailsChange.emit(this.formControl.value);
  }

  ngOnDestroy() {
    if (this.formControl && this.formControl.dirty) {
      this.updatePaymentDetails();

      this.formControl.markAsPristine();
    }
  }
}
